<template>
 <div>


  <div class="container" @click="close">
    </div>
    <div class="popup">
      <div class="information-main">
        <div class="closeBox">
          <div @click="close" class="cha">X</div>
        </div>
        <div class="Information-header">
          <h4>交通违法信息</h4>
          <ul v-for="(item,index) in CarViolation" :key='index' v-show="CarType">
            <li>
              <span>违法编号</span>
              <b>{{ item.violationCode }}</b>
            </li>
            <li>
              <span>违法时间</span>
              <b>{{item.lossTime}}</b>
            </li>
            <li>
              <span>违法代码</span>
              <b>{{item.lossAction}}}</b>
            </li>
            <li>
              <span>违法类型</span>
              <b>{{item.peccancySort}}}</b>
            </li>
            <li>
              <span>违法类型简称</span>
              <b>{{item.remark}}}</b>
            </li>
            <li>
              <span>决定书编号</span>
              <b>{{item.decisionCode}}</b>
            </li>
            <li>
              <span>行政区域代码</span>
              <b>{{item.administrationArea}}</b>
            </li>
          </ul>
          <p v-show="!CarType">未查询到相关数据</p>
        </div>
        <div class="Compulsory-Information">
          <h4>交强险理赔信息</h4>
          <ul v-for="(item,index) in JQViolation" :key='index' v-show="JQtype">
            <li>
              <span>保险公司</span>
              <b>{{item.payCompany}}</b>
            </li>
            <li>
              <span>保单号</span>
              <b>{{item.policyNo}}</b>
            </li>
            <li>
              <span>保险起期</span>
              <b>{{item.startDate}}</b>
            </li>
            <li>
              <span>保险止期</span>
              <b>{{item.endDate}}</b>
            </li>
            <li>
              <span>出险时间</span>
              <b>{{item.lossTime}}</b>
            </li>
            <li>
              <span>结案时间</span>
              <b>{{item.endCaseTime}}</b>
            </li>
            <li>
              <span>赔付金额</span>
              <b>{{item.lossFee}}</b>
            </li>
            <li>
              <span>是否死亡</span>
              <b>{{item.accidentName}}</b>
            </li>
            <li>
              <span>理赔类型</span>
              <b>{{item.claimname}}</b>
            </li>
            <li>
              <span>保单归属地</span>
              <b>{{item.insurerArea}}</b>
            </li>
          </ul>
          <p v-show="!JQtype">未查询到相关数据</p>
        </div>
        <div class="Business-information">
          <h4>商业险理赔信息</h4>
          <ul v-for="(item,index) in SYViolation" :key='index' v-show="SYtype">
            <li>
              <span>保险公司</span>
              <b>{{item.payCompany}}</b>
            </li>
            <li>
              <span>保单号</span>
              <b>{{item.policyNo}}</b>
            </li>
            <li>
              <span>保险起期</span>
              <b>{{item.startDate}}</b>
            </li>
            <li>
              <span>保险止期</span>
              <b>{{item.endDate}}</b>
            </li>
            <li>
              <span>出险时间</span>
              <b>{{item.lossTime}}</b>
            </li>
            <li>
              <span>结案时间</span>
              <b>{{item.endCaseTime}}</b>
            </li>
            <li>
              <span>赔付金额</span>
              <b>{{item.lossFee}}</b>
            </li>
            <li>
              <span>是否死亡</span>
              <b>{{item.accidentName}}</b>
            </li>
            <li>
              <span>理赔类型</span>
              <b>{{item.claimname}}</b>
            </li>
            <li>
              <span>保单归属地</span>
              <b>{{item.insurerArea}}</b>
            </li>
          </ul>
          <p v-show="!SYtype">未查询到相关数据</p>
        </div>
      </div>
    </div>

   </div>
</template>
<script>
export default {
  data () {
    return {
      CarViolation: [], // 车辆违章信息
      SYViolation: [], // 商业信息
      JQViolation: [], // 交强信息
      CarType: false, // 显示异常车辆信息
      SYtype: false,
      JQtype: false
    }
  },
  props:{
    isPopupVisible:{
      type: Boolean
    }
  },
  watch: {
    isPopupVisible(value) {
      if (value) {
        let data = JSON.parse(localStorage.getItem('Popdate'))
        this.$store.commit('setShow',false)
        this.getViolation(data)
      }
    }
  },
  activated () {
    // let data = this.$route.params.data
  },
  methods: {
    close (){
      this.$emit('close')
    },
    getViolation (val) {
      if (val.illegalInfoList !== '' && val.illegalInfoList !== null) {
        this.CarViolation = val.illegalInfoList
      }
      if (val.hisClaimList !== '' && val.hisClaimList !== null) {
        for (let index = 0; index < val.hisClaimList.length; index++) {
          switch (val.hisClaimList[index].claimType) {
            case '0':
              val.hisClaimList[index].claimname = '有责涉及死亡赔案'
              break
            case '1':
              val.hisClaimList[index].claimname = '有责不涉及死亡赔案'
              break
            case '2':
              val.hisClaimList[index].claimname = '无责赔案'
              break
            case '3':
              val.hisClaimList[index].claimname = '垫付赔案'
              break
            case '4':
              val.hisClaimList[index].claimname = '垫付救助基金'
              break
            case '9':
              val.hisClaimList[index].claimname = '其它'
              break
          }
          switch (val.hisClaimList[index].accidentDeath) {
            case '1':
              val.hisClaimList[index].accidentName = '是'
              break
            case '0':
              val.hisClaimList[index].accidentName = '否'
              break
          }
          if (val.hisClaimList[index].kindCode === '0501' || val.hisClaimList[index].kindCode === '050A') { // 商业
            this.SYViolation.push(val.hisClaimList[index])
          } else if (val.hisClaimList[index].kindCode === '0590') { // 交强
            this.JQViolation.push(val.hisClaimList[index])
          }
        }
      }

      if (this.CarViolation.length !== 0) {
        this.CarType = true
      } else {
        this.CarType = false
      }
      if (this.SYViolation.length !== 0) {
        this.SYtype = true
      } else {
        this.SYtype = false
      }
      if (this.JQViolation.length !== 0) {
        this.JQtype = true
      } else {
        this.JQtype = false
      }
    }
  }
}
</script>
<style>
  html{
    background: #F7F6F9;
  }
</style>
<style lang="scss" scoped>
@import "./PlatformInformation.scss";
</style>



// WEBPACK FOOTER //
// src/pages/car/PlatformInformation/PlatformInformation.vue